import React from 'react';

const SITE_ORIGIN = 'https://www.buildlabconsulting.com';

/**
 * Renders a JSON-LD structured-data <script> tag.
 * Usage: <JsonLd data={{ '@type': 'WebApplication', ... }} />
 * The @context is added automatically when missing.
 */
const JsonLd = ({ data }) => {
    if (!data) return null;
    const payload = data['@context'] ? data : { '@context': 'https://schema.org', ...data };
    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(payload) }} />
    );
};

/**
 * WebApplication schema for the free calculator/checker tools.
 * `path` is the root-relative route (e.g. '/low-voltage-budget-estimator').
 */
export const webAppSchema = ({ name, description, path }) => ({
    '@type': 'WebApplication',
    name,
    description,
    url: `${SITE_ORIGIN}${path}/`,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    provider: { '@type': 'Organization', name: 'BUILDLAB', url: SITE_ORIGIN },
});

export default JsonLd;
